import Http from "./base-http";
class Availability extends Http {
  deleteCompanyAvailability(id) {
    return this.destroy(id);
  }
  addAvailability(variables) {
    return this.create(variables);
  }
}

const availabilityObj = new Availability({
  modelUrlPrefix : "availability"
});

export default availabilityObj;
